import { download } from 'utils/client';

const filesAPI = {
  downloadFile(id: string) {
    return download(`files/${id}/download`);
  },
};

export default filesAPI;
